if not App.angularApp?
    return

App.angularApp.directive 'mfCustomDataPdfDownloadFixedTableHeader', ['$window', '$rootScope', ($window, $rootScope) ->
    return {
        link: (scope, ele, attrs) =>
            # This directive can only be used with the data page sidebar
            # (This version is for the sidebar table in pdf download).
            # The custom logic in this directive will break things if you try to use it anywhere else.

            calculatePixels = () =>

                if scope.hax is true

                    # There is this much padding between elements in the div that needs to be accounted for
                    padding = 120
                    children_height = 0
                    container_height = ($('#sidebar-content')[0].clientHeight - padding)

                    if ele[0].children

                        for child in ele[0].children
                            do =>
                                if child.className is 'forms-table-container ng-scope'
                                    # dont add these because theyre the tables we are getting sizes for
                                else
                                    children_height += child.clientHeight

                        scope.available_pixels = (container_height - children_height)
                        handleTableHeight()


            handleTableHeight = () =>
                scope.form_table_needed_pixels = (49 + (scope.rows.length * 29))

                debug = false

                form = scope.form_table_needed_pixels
                total_width = $('#row_head').width()

                available = scope.available_pixels

                if not scope.sized
                    scope.form_table_style = 'height': available
                    scope.width_style = 'width': total_width / 2
                    scope.sized = true

                $rootScope.$broadcast('resizer:loaded', {})

            # Need to initialize on load
            calculatePixels()

            # resize on window resize
            angular.element($window).bind 'resize', debounce () =>
                calculatePixels()
    }
]
